import gql from 'graphql-tag';

export const DELETE_EVENT_MUTATION = gql`
  mutation DeleteEvent($id: ID!) {
    deleteEvent(id: $id) {
      event {
        id
      }
    }
  }
`;
